(() => {
  const instances = new WeakMap();
  const sliderQuery = window.matchMedia('(max-width: 989px)');

  function initSection(root = document) {
    const sliders = root.querySelectorAll('[data-occasion-collections-slider]');

    sliders.forEach((slider) => {
      const current = instances.get(slider);

      if (sliderQuery.matches) {
        if (current || typeof Swiper === 'undefined') return;

        const pagination = slider.querySelector('.occasion-collections__pagination');
        const swiper = new Swiper(slider, {
          slidesPerView: 1.12,
          spaceBetween: 14,
          speed: 450,
          pagination: {
            el: pagination,
            clickable: true,
          },
          breakpoints: {
            480: {
              slidesPerView: 1.35,
              spaceBetween: 16,
            },
            640: {
              slidesPerView: 1.8,
              spaceBetween: 18,
            },
            750: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            900: {
              slidesPerView: 4,
              spaceBetween: 18,
            },
          },
        });

        instances.set(slider, swiper);
        return;
      }

      if (current) {
        current.destroy(true, true);
        instances.delete(slider);
      }
    });
  }

  function ready() {
    initSection();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }

  sliderQuery.addEventListener('change', () => initSection());

  document.addEventListener('shopify:section:load', (event) => {
    initSection(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-occasion-collections-slider]').forEach((slider) => {
      const current = instances.get(slider);
      if (!current) return;

      current.destroy(true, true);
      instances.delete(slider);
    });
  });
})();
